export const GET_TERMS_CONDITIONS_REQUEST = 'GET_TERMS_CONDITIONS_REQUEST'
export const GET_TERMS_CONDITIONS = 'GET_TERMS_CONDITIONS'

export const CREATE_TERMS_CONDITIONS_REQUEST = 'CREATE_TERMS_CONDITIONS_REQUEST'
export const CREATE_TERMS_CONDITIONS = 'CREATE_TERMS_CONDITIONS'

export const UPDATE_TERMS_CONDITIONS_REQUEST = 'UPDATE_TERMS_CONDITIONS_REQUEST'
export const UPDATE_TERMS_CONDITIONS = 'UPDATE_TERMS_CONDITIONS'

export const DELETE_TERMS_CONDITIONS_REQUEST = 'DELETE_TERMS_CONDITIONS_REQUEST'
export const DELETE_TERMS_CONDITIONS = 'DELETE_TERMS_CONDITIONS'

export const GET_TERMS_CONDITIONS_REQUEST_PENDING = 'GET_TERMS_CONDITIONS_REQUEST_PENDING'
export const GET_TERMS_CONDITIONS_REQUEST_SUCCESS = 'GET_TERMS_CONDITIONS_REQUEST_SUCCESS'
export const GET_TERMS_CONDITIONS_REQUEST_ERROR = 'GET_TERMS_CONDITIONS_REQUEST_ERROR'

export const CHANGE_TERMS_CONDITIONS_REQUEST_PENDING = 'CHANGE_TERMS_CONDITIONS_REQUEST_PENDING'
export const CHANGE_TERMS_CONDITIONS_REQUEST_SUCCESS = 'CHANGE_TERMS_CONDITIONS_REQUEST_SUCCESS'
export const CHANGE_TERMS_CONDITIONS_REQUEST_ERROR = 'CHANGE_TERMS_CONDITIONS_REQUEST_ERROR'
